import { Grid } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import { functions } from 'helpers/functions';
import React, { Component } from 'react';
import styles from 'scenes/Producer/Product/EditProduct/components/styles';
import { EProductType } from 'v2/interfaces/product';
import { run } from 'validations/ruleRunner';

import BlockedFieldTooltipProps from './../../../General/blockedTooltipProps';
import Validations from './validations';

interface IProps {
  offer: any;
  handleChange: any;
  onChangeRequiredFields?: any;
  loading: boolean;

  classes?: any;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

class SinglePayment extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.offer, Validations),
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  onChangeStates = () => {
    let { offer, onChangeRequiredFields } = this.props;
    let newState = { ...this.state };
    newState.validationErrors = run(offer, Validations);
    this.setState(newState);

    if (onChangeRequiredFields) {
      onChangeRequiredFields('singlePaymentErrors', newState.validationErrors);
    }
  };

  componentDidUpdate(prevProps: IProps) {
    const { loading, offer } = this.props;

    if (!loading && offer !== prevProps.offer && offer.charge_type === 'N') {
      this.onChangeStates();
    }
  }

  componentDidMount() {
    const { loading, offer } = this.props;
    if (!loading && offer.charge_type === 'N') {
      this.onChangeStates();
    }
  }

  render() {
    const { offer, handleChange } = this.props;

    const isAlumy = offer.type === EProductType.ALUMY;
    const isBlinket = offer.type === EProductType.TICKET;

    return (
      <Grid item xs={12}>
        <BlockedFieldTooltipProps product={offer} enabled={isAlumy || isBlinket}>
          <div>
            <CustomMaskedInput
              label='Preço'
              fullWidth={true}
              disableUnderline
              id='price'
              helperText={this.isValid('price') ? this.errorFor('price') : 'Ex: 1.000,00'}
              error={this.isValid('price')}
              mask='money'
              value={functions.addMoneyMask(offer.price)}
              onChange={(value: any) => handleChange('price', value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={isAlumy || isBlinket}
            />
          </div>
        </BlockedFieldTooltipProps>
      </Grid>
    );
  }
}

export default styles(SinglePayment);
